import React from 'react'
import { Button } from '@enamelai/design-system'

type GeneratePDFButtonProps = {
  handleGeneratePDF: () => void
}

const GeneratePDFButton = ({
  handleGeneratePDF,
}: GeneratePDFButtonProps): React.ReactElement => (
  <Button type="button" variant="primary" onClick={handleGeneratePDF}>
    Generate PDF
  </Button>
)

export default GeneratePDFButton
